import React, { useState } from "react";
import { IoAdd } from "react-icons/io5";
import { FaPoundSign } from "react-icons/fa";
import Modal from "./models/Model.jsx";
import bugerImage from "../../assets/burgerimage.png";

// TruncatedText Component
const TruncatedText = ({ text, maxWords, limitWords }) => {
  const truncateText = (str, max, limit) => {
    const words = str.split(" ");
    if (words.length > limit) {
      return words.slice(0, max).join(" ") + "...";
    }
    return str;
  };

  return <p className="text-sm text-white">{truncateText(text, maxWords, limitWords)}</p>;
};
function MenuCard({ item, allProducts, allCategory }) {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const handleCardClick = () => {
    if (!showModal) {
      setModalData(item);
      setShowModal(true);
    }
  };

  const handleAddClick = (e) => {
    e.stopPropagation();
    setModalData(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div
      className="flex flex-col p-4 mx-auto rounded-3xl shadow-lg bg-[#b91c1c] border border-gray-200 
      md:h-[370px] h-[350px] w-full sm:w-[280px] md:w-[180px] lg:w-[250px] cursor-pointer"
      onClick={handleCardClick}
    >
      {/* Image */}
      <img
        src={item.images?.[0] || bugerImage}
        alt={item.name}
        className="object-cover w-full rounded-xl h-[160px] md:h-[180px] lg:h-[200px]"
      />
  
      {/* Title and Price */}
      <div className="mt-4 flex justify-between items-center">
        <h2 className="text-md md:text-lg font-bold text-white truncate">{item.name}</h2>
        <p className="text-md md:text-lg text-white flex items-center">
          <FaPoundSign className="" /> {item.price}
        </p>
      </div>
  
      {/* Description */}
      <TruncatedText text={item.description || ""} maxWords={10} limitWords={10} />
  
      {/* Add Button */}
      <div className="mt-auto flex justify-end items-end">
        <div
          className="bg-white text-[#b91c1c] w-8 h-8 flex justify-center items-center cursor-pointer rounded-full"
          onClick={handleAddClick}
        >
          <IoAdd  size={20} />
        </div>
      </div>
  
      {/* Modal */}
      {showModal && (
        <Modal
          data={modalData}
          allProducts={allProducts}
          onClose={handleCloseModal}
          allCategory={allCategory}
        />
      )}
    </div>
  );
  
}

export default MenuCard;
